﻿module.exports = (function ($) {
    return {
        init: function () {
            var self = this;
            self.alignTitleHeights();
            $(window).resize(function () {
                // Reset height
                self.alignTitleHeights();
            });

            if ($('[data-homeherocarousel]').length > 0)
                self.initHomeCarousel();

            if ($('[data-monocarousel]').length > 0)
                self.initPageCarousels();

        },
        initHomeCarousel: function () {
            // Slick carousel plugin
            $('[data-homeherocarousel]').show().slick({
                dots: true,
                prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Previous</span><span class="slick-arrow-prev"></span></button>',
                nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Next</span><span class="slick-arrow-next"></span></button>',
                slide: '.homePageSlider__carouselItem'
            });
        },
        initPageCarousels: function () {

            var self = this;
            // Slick carousel plugin
            $('[data-monocarousel]').each(function () {
                // Fires after first initialization.
                $(this).on('init', function (slick) {
                    $('.monoCarousel .monoCarousel__title').height('auto');
                    self.alignTitleHeights();
                });

                var slides = $(this).find('.monoCarousel__item').length;
                var show = slides <= 3 ? slides - 1 : 3;

                $(this).show().slick({
                    dots: true,
                    slidesToShow: show,
                    slidesToScroll: 1,
                    prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Previous</span><span class="slick-arrow-prev"></span></button>',
                    nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Next</span><span class="slick-arrow-next"></span></button>',
                    slide: '.monoCarousel__item',
                    responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true
                        }
                    }]
                });
            });

            
        },
        alignTitleHeights: function () {
            
            $('.monoCarousel').each(function () {
                $(this).find('.monoCarousel__title').equalizeHeights();
            });
        }
    };
});

